import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import {
  parseTrafficCongestion,
  parseVolumeData,
} from "./api";
import { parseStatsLatencyData } from "views/Statistics/System/StatsLatency/api";
import { parseStatsRtxData } from "views/Statistics/System/StatsRtx/api";
import RangeSliderInput from "common/RangeSliderInput";
import ActionsContext from "common/ActionsContext";
import { retrieveRange } from "common/api";
import Charts from "./CongestionCharts";
import { TileContainer } from "./utils";
import BqnContext from "common/BqnContext";
import { ClusterCongestionCharts } from "./ClusterCongestionCharts";

const SingleColumn = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-flow: column;
  width: 100%;
  
  svg .nv-y.nv-axis {
    .nv-axisMaxMin {
    display: none;
    }
  }
`;

const linesFromHours = (hours) => hours * (60 / 5);

const CongestionReport = ({hours, aggregateBqns}) => {
  const actions = useContext(ActionsContext);
  const [range, setRange] = useState();
  const [initialRange, setInitialRange] = useState();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  const loadStatistics = ({ lines = 10, hours, bqnId }) => {
    const bqnIdParam = bqnId != null ? ` bqn-id ${bqnId}` : "";
    return Promise.all([
      ifCl
        .run(`show statistics congestion lines ${lines}${bqnIdParam}`)
        .then(parseTrafficCongestion),
      ifCl
        .run(`show statistics latency-percentile lines ${lines}${bqnIdParam}`)
        .then(parseStatsLatencyData),
      ifCl
        .run(`show statistics retransmission lines ${lines}${bqnIdParam}`)
        .then(parseStatsRtxData),
      ifCl
        .run(`show statistics volume mbps-max hours ${hours} interval 5${bqnIdParam}`)
        .then(parseVolumeData),
    ]).then(([congestion, latency, retransmission, throughput]) => {
      setResult({
        congestion,
        latency,
        retransmission,
        throughput,
      })
      setLoading(false);
    });
  };

  const doLoad = (withRange = true) => {
    const loadStats = () => {
      removeTooltips();
      setLoading(true);
      if (aggregateBqns === false ) {
        return null;
      }
      return loadStatistics({ 
        hours, 
        lines: linesFromHours(hours), 
        bqnId: mode === "cluster" && bqnId !== "all" ? bqnId : null,
      });
    }
    if (withRange) {
      setRange(undefined);
      retrieveRange(hours).then(setInitialRange).then(loadStats);
    } else {
      loadStats();
    }
  }

  function removeTooltips() {
    $(".nvtooltip").remove();
  }

  useEffect(() => {
    doLoad();
    
    return () => {
      removeTooltips();
    }
  }, [hours]);

  useEffect(() => {
    doLoad(false);

    return actions.recv("do-load", () => doLoad(false));
  }, [bqnId, aggregateBqns]);

  return (
    <SingleColumn>
      { aggregateBqns === false ? (
          <ClusterCongestionCharts range={range || initialRange} hours={hours} />
        ) : (
        <Charts
          {...result}
          range={range || initialRange}
          hours={hours}
          loading={loading}
        />
      )}
      <TileContainer className="full-width can-compress">
        {initialRange ? (
          <RangeSliderInput
            {...initialRange}
            onChange={(value) => setRange(value)}
          />
        ) : null}
      </TileContainer>
    </SingleColumn>
  );
};

export default CongestionReport;
